<template>
  <div class="page-wrapper">
    <HeaderComponent />
    <div class="page-content">
      <AppBreadcrumb :items="[{ label: $t('fines.breadcrumb') }]" />


      <a-table
        :dataSource="fines"
        :pagination="false"
        rowKey="id"
        class="theme-aware-box"
      >
        <a-table-column :title="$t('fines.number')" key="id" data-index="id" />
        <a-table-column :title="$t('fines.type')" key="title" data-index="title" />
        <a-table-column :title="$t('fines.amount')" key="amount" data-index="amount" />
      </a-table>
    </div>
  </div>
</template>

<script>
import HeaderComponent from '../components/HeaderComponent.vue'
import AppBreadcrumb from '../components/AppBreadcrumb.vue'
import api from '@/api/axios'

export default {
  components: {
    HeaderComponent,
    AppBreadcrumb
  },
  data() {
    return {
      fines: []
    }
  },
  async mounted() {
    try {
      const { data } = await api.get('/v1/fines/')
      this.fines = data.results || []
    } catch (e) {
      console.error('Fines fetch error:', e)
    }
  }
}
</script>